<footer class="bg-dark-surface border-t border-white/5 pt-12 pb-8 mt-auto text-sm text-dark-text-muted">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
      <!-- Column 1: Restaurant Info -->
      <div>
        <span class="text-xl font-bold font-elegant bg-linear-to-r from-rainbow-orange to-rainbow-yellow bg-clip-text text-transparent mb-4 block">
          Ресторант "Дъгата"
        </span>
        <p class="leading-relaxed mb-4">
          Качествено приготвена храна, подбрани съставки и бърза доставка с отлично обслужване за град Лом и околните села. Поръчайте с няколко клика!
        </p>
        <p class="text-xs">
          © {{ currentYear }} Дъгата Лом. Всички права запазени.
        </p>
      </div>

      <!-- Column 2: Working Hours & Location -->
      <div>
        <h3 class="text-white font-semibold mb-4 text-base">Работно Време & Адрес</h3>
        <ul class="space-y-2 mb-5">
          <li class="flex items-start space-x-2">
            <span class="text-rainbow-orange">🕒</span>
            <span>Понеделник - Събота: 08:00 - 23:00 ч.</span>
          </li>
          <li class="flex items-start space-x-2">
            <span class="text-rainbow-orange">📍</span>
            <span>ул. Славянска 21, гр. Лом</span>
          </li>
          <li class="flex items-start space-x-2">
            <span class="text-rainbow-orange">📞</span>
            <span>+359 895 788 911</span>
          </li>
        </ul>

        <h4 class="text-white font-medium mb-3 text-xs uppercase tracking-wider">Последвайте ни</h4>
        <div class="flex space-x-4">
          <!-- Facebook -->
          <a href="https://www.facebook.com/dagatalom" target="_blank" rel="noopener noreferrer"
             class="text-dark-text-muted hover:text-white flex items-center space-x-2 transition duration-200 cursor-pointer">
            <img src="/assets/images/facebook.svg" alt="Facebook" class="h-6 w-6 opacity-85 hover:opacity-100 transition duration-200">
            <span class="text-sm font-medium">Facebook</span>
          </a>
          <!-- Instagram -->
          <a href="https://www.instagram.com/dagatalom" target="_blank" rel="noopener noreferrer"
             class="text-dark-text-muted hover:text-white flex items-center space-x-2 transition duration-200 cursor-pointer">
            <img src="/assets/images/instagram.svg" alt="Instagram" class="h-6 w-6 opacity-85 hover:opacity-100 transition duration-200">
            <span class="text-sm font-medium">Instagram</span>
          </a>
        </div>
      </div>

      <!-- Column 3: Links & Social Media -->
      <div>
        <h3 class="text-white font-semibold mb-4 text-base">Връзки</h3>
        <div class="flex flex-col space-y-2 mb-4">
          <a routerLink="/menu" class="hover:text-white transition duration-200">Разгледай Менюто</a>
          <a routerLink="/profile" class="hover:text-white transition duration-200">Твоят Профил</a>
          <a routerLink="/delivery-info" class="hover:text-white transition duration-200">Доставка</a>
          <a routerLink="/terms" class="hover:text-white transition duration-200">Общи условия</a>
          <a routerLink="/privacy" class="hover:text-white transition duration-200">Политика за поверителност</a>
        </div>
      </div>
    </div>

    <div class="border-t border-white/5 pt-8 flex flex-col lg:flex-row items-center justify-between text-xs gap-4">
      <div class="flex items-center gap-3 select-none">
        <img ngSrc="/assets/images/unicredit.svg" alt="UniCredit" class="h-6 w-auto bg-white p-1 rounded-md" height="33"
             width="301">
        <img ngSrc="/assets/images/visa.svg" alt="Visa" class="h-6 w-auto bg-white p-1 rounded-md" height="16"
             width="16">
        <img ngSrc="/assets/images/mastercard.svg" alt="Mastercard" class="h-6 w-auto bg-white p-1 rounded-md"
             height="60" width="100">
      </div>
      <p class="text-center md:text-right text-dark-text-muted">
        Приемаме плащания с банкови карти Visa и Mastercard през Виртуален ПОС терминал на УниКредит Булбанк.
      </p>
    </div>
  </div>
</footer>
